import React from "react";
import { Link } from "react-router-dom";
import logo from "../../img/LogoWhite.png";
import styles from "./header.module.css";

function Header() {
  return (
    <div className={styles.background + " text-center"}>
      <div className="d-flex align-items-center justify-content-center h-100">
        <div className="text-center">
          <img src={logo} width="300px" alt="Logo" />
          <h1 className={styles.h1Home}>
            ¿Buscando qué merendar? ¡Llegaste al lugar!
          </h1>
          <div className="">
            <button className={styles.btnHome}>
              <Link to="/products" className="text-decoration-none text-white">
                Tienda
              </Link>
            </button>
            <button className={styles.btnHome}>
              <Link to="/about" className="text-decoration-none text-white">
                Nosotros
              </Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
